"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPortalContext = void 0;
var react_1 = require("react");
/*
 * Provides default element for the portal property
 */
exports.DefaultPortalContext = react_1.createContext(null);
//# sourceMappingURL=DefaultPortalContext.js.map